// export const SERVER_URL = "http://172.105.60.238:3001";
export const SERVER_URL = "https://akivapanelapi.secretdemo.com"; // LIVE
// export const SERVER_URL = "https://akivaapi.secretdemo.com"; // Demo
// export const SERVER_URL = "http://192.168.1.134:3001";